import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import {
  Button,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import classNames from 'classnames';
import moment from 'moment';

const styles = {
  root: {
    boxShadow: 'none'
  },
  contentContainer: {
    padding: '0 0 40px',
    backgroundColor: '#fff',
    borderRadius: 4,
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    '@media (max-height: 750px)': {
      maxHeight: 600,
      overflowY: 'auto'
    }
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 10,
    textAlign: 'center'
  },
  closeButton: {
    cursor: 'pointer'
  },
  closeIcon: {
    width: '30px',
    height: '30px'
  },
  header: {
    textAlign: 'right',
    padding: '8px'
  },
  body: {
    padding: '0 16px'
  },
  table: {
    width: '100%'
  },
  tableHeader: {
    backgroundColor: 'rgba(224, 224, 224, 1)'
  },
  tableCell: {
    borderTop: '#F7F7F7',
    backgroundColor: '#F7F7F7',
    padding: '8px 12px',
    fontSize: 14
  },
  tableCellBody: {
    fontSize: 16,
    fontWeight: 700,
    maxWidth: 80,
    padding: '4px 8px'
  },
  marginTop20: {
    marginTop: 20
  },
  buttonConfirm: {
    width: '100%'
  },
  tableContainer: {
    maxHeight: 400,
    overflowY: 'auto'
  },
  lastUpdateAmountBox: {
    textAlign: 'end',
    marginTop: 20
  },
  lastUpdateAmountTitle: {
    backgroundColor: '#F7F7F7',
    borderTop: '1px solid #E0E0E0',
    borderBottom: '1px solid #E0E0E0',
    padding: '8px 12px',
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'center'
  },
  lastUpdateAmountContent: {
    borderTop: '1px solid #E0E0E0',
    borderBottom: '1px solid #E0E0E0',
    padding: '8px 12px',
    fontSize: 14,
    fontWeight: 700,
    textAlign: 'center'
  }
};

const enhance = compose();

const Main = enhance(
  ({ classes, setShowUpdateAmountHistoryModal, updateAmountHistoryDetail }) => {
    return (
      <>
        <Paper className={classes.root} id="scrollTableAdd">
          <div className={classes.contentContainer}>
            <div className={classes.header}>
              <Button
                className={classes.closeButton}
                onClick={() => {
                  setShowUpdateAmountHistoryModal(false);
                }}
              >
                <CloseIcon className={classes.closeIcon} />
              </Button>
            </div>

            <div className={classes.body}>
              <Typography className={classes.title} variant="h6">
                金額修正履歴
              </Typography>

              <Table className={classes.table}>
                <TableHead className={classes.tableHeader}>
                  <TableRow>
                    <TableCell className={classes.tableCell}>
                      使用日時
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      コース名
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      使用金額
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCellBody}>
                      {updateAmountHistoryDetail &&
                      updateAmountHistoryDetail.useDate !== null
                        ? moment(updateAmountHistoryDetail.useDate).format(
                            'YYYY-MM-DD THH:mm:ss'
                          )
                        : ''}
                    </TableCell>
                    <TableCell className={classes.tableCellBody}>
                      {updateAmountHistoryDetail &&
                      updateAmountHistoryDetail.menuName !== null
                        ? updateAmountHistoryDetail.menuName
                        : ''}
                    </TableCell>
                    <TableCell className={classes.tableCellBody}>
                      {updateAmountHistoryDetail &&
                      updateAmountHistoryDetail.firstUseAmount !== null
                        ? `${updateAmountHistoryDetail.firstUseAmount.toLocaleString()}円`
                        : ''}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <div
                className={classNames(
                  classes.tableContainer,
                  classes.marginTop20
                )}
              >
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeader}>
                    <TableRow>
                      <TableCell className={classes.tableCell}>
                        修正日時
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        操作者
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        修正情報
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {updateAmountHistoryDetail &&
                      updateAmountHistoryDetail.historyEditList &&
                      updateAmountHistoryDetail.historyEditList.length > 0 &&
                      updateAmountHistoryDetail.historyEditList.map(item => (
                        <TableRow>
                          <TableCell className={classes.tableCellBody}>
                            {item.editedAt !== null
                              ? moment(item.editedAt).format(
                                  'YYYY-MM-DD THH:mm:ss'
                                )
                              : ''}
                          </TableCell>
                          <TableCell className={classes.tableCellBody}>
                            {item.editedBy === 'SECRETARIAT'
                              ? '事務局'
                              : '参画事業者'}
                          </TableCell>
                          <TableCell className={classes.tableCellBody}>
                            <div>
                              {item.oldAmount !== null
                                ? `${item.oldAmount.toLocaleString()}円`
                                : ''}
                            </div>
                            <div>
                              <KeyboardArrowDownIcon />
                            </div>
                            <div>
                              {item.newAmount !== null
                                ? `${item.newAmount.toLocaleString()}円`
                                : ''}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>

              <div className={classes.lastUpdateAmountBox}>
                <span className={classes.lastUpdateAmountTitle}>
                  金額修正後振込額
                </span>
                <span className={classes.lastUpdateAmountContent}>
                  {updateAmountHistoryDetail &&
                  updateAmountHistoryDetail.lastUseAmount !== null
                    ? `${updateAmountHistoryDetail.lastUseAmount.toLocaleString()}円`
                    : ''}
                </span>
              </div>

              <div className={classes.marginTop20}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowUpdateAmountHistoryModal(false);
                  }}
                  className={classes.buttonConfirm}
                >
                  閉じる
                </Button>
              </div>
            </div>
          </div>
        </Paper>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
